<template>
	<div>
		<!-- NAVBAR  -->
		<nav class="topnav navbar custom_navbar navbar-expand-lg navbar-dark nav_color fixed-top"
			style="height: 3.75rem">
			<img class="navbar-brand" style="max-height: 38px;" src="/assets/img/main.png">
			<button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarColor02"
				aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="container">
				<div class="navbar-collapse collapse" id="navbarColor02">
					<ul class="navbar-nav row mr-auto d-flex align-items-center nav-ul">
						<li class="nav-item">
							<router-link class="nav-link main-link" to="/home"
								:class="{ active: this.$route.name == 'Home' }"><span>Home</span></router-link>
						</li>
						<!-- 产品页 -->
						<li class="nav-item">
							<router-link class="nav-link main-link" to="/main/products/"
								:class="{ active: this.$route.name == 'products' }"><span>Products</span></router-link>
						</li>

						<!-- 新闻页 -->
						<!-- <li class="nav-item dropdown dropdown-animate" data-toggle="hover">
							<a class="nav-link  main-link" href="#" role="button" data-toggle="dropdown"
								aria-haspopup="true" aria-expanded="false"
								:class="{ active: this.$route.name == 'news' }"><span>News</span></a>
							<div class="dropdown-menu">
								<ul class="navbar-nav sub_navbar_nav row" style="display: contents;">
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/news/NewsCom"
											:class="{ active: $route.path === '/main/news/NewsCom' }">Company
											News</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/news/NewsIns"
											:class="{ active: $route.path === '/main/news/NewsIns' }">Industry
											News</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/news/NewsTec"
											:class="{ active: $route.path === '/main/news/TechnicalSupport' }">Technical
											Support</router-link>
									</li>
								</ul>
							</div>
						</li> -->
						<li class="nav-item">
							<keep-alive><router-link class="nav-link main-link" to="/main/news/NewsCom"
								:class="{ active: this.$route.name == 'news' }"><span>News</span></router-link></keep-alive>
							
						</li>

						<!-- VIP中心 -->
						<li class="nav-item dropdown dropdown-animate" data-toggle="hover">
							<a class="nav-link  main-link" href="#" role="button" data-toggle="dropdown"
								aria-haspopup="true" aria-expanded="false"
								:class="{ active: this.$route.name == 'vipCenter' }"><span>VIP Center</span></a>
							<!-- <div class="dropdown-menu" v-if="user||$isDevelopment"> -->
							<div class="dropdown-menu">
								<ul v-if="user||$isDevelopment" class="navbar-nav sub_navbar_nav row" style="display: contents;">
									<!-- <li class="nav-item  col">
										<router-link class="nav-link" to="/vipCenter/JoinVIP"
											:class="{ active: $route.path === '/vipCenter/JoinVIP' }">Join
											VIP</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/vipCenter/NewProduct"
											:class="{ active: $route.path === '/vipCenter/NewProduct' }">New
											Product</router-link>
									</li> -->
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/vipCenter/ProjectProgress"
											:class="{active: $route.path === '/main/vipCenter/ProjectProgress'}">
											Project progress</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/vipCenter/OrderProgress"
											:class="{ active: $route.path === '/main/vipCenter/OrderProgress' }">
											Order progress</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/vipCenter/Favorite"
											:class="{ active: $route.path === '/main/vipCenter/Favorite' }">Favorite</router-link>
									</li>

									<!-- <li class="nav-item col">
										<router-link class="nav-link" to="/main/vipCenter/certificate"
											:class="{ active: $route.path === '/main/vipCenter/certificate' }">Certificate</router-link>
									</li> -->
								</ul>
								<ul id="disablelist" v-else class="navbar-nav sub_navbar_nav row"
									style="display: contents;">

									<li class="nav-item col">
										<router-link class="nav-link" to=""
											:class="{active: $route.path === '/main/vipCenter/ProjectProgress'}">
											Project progress</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to=""
											:class="{ active: $route.path === '/main/vipCenter/OrderProgress' }">
											Order progress</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to=""
											:class="{ active: $route.path === '/main/vipCenter/Favorite' }">Favorite</router-link>
									</li>
								</ul>
							</div>
						</li>
						<!-- 下载页 -->
						<!-- <li class="nav-item">
							<router-link class="nav-link main-link" to="/main/download/ProductBrochure"
								:class="{ active: this.$route.name == 'download' }"><span>Download</span></router-link>
						</li> -->
						<li class="nav-item dropdown dropdown-animate" data-toggle="hover">
							<a class="nav-link  main-link" href="#" role="button" data-toggle="dropdown"
								aria-haspopup="true" aria-expanded="false"
								:class="{ active: this.$route.name == 'download' }"><span>Download</span></a>
							<div class="dropdown-menu">
								<ul class="navbar-nav sub_navbar_nav row" style="display: contents;">
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/download/ProductBrochure"
											:class="{ active: $route.path === '/main/download/ProductBrochure' }">
											Brochure</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/download/certificate"
											:class="{ active: $route.path === '/main/download/certificate' }">Certificate</router-link>
									</li>
									<!-- <li class="nav-item col">
										<router-link class="nav-link" to="/download/ProductManual"
											:class="{ active: $route.path === '/download/ProductManual' || $route.path === '/download/DownloadDetails' }">Product
											Manual</router-link>
									</li>

									<li class="nav-item col">
										<router-link class="nav-link" to="/download/OrderInquiry"
											:class="{ active: $route.path === '/download/OrderInquiry' }">Order
											Inquiry</router-link>
									</li> -->
								</ul>
							</div>
						</li>
						<!-- 关于我们 -->
						<li class="nav-item dropdown dropdown-animate" data-toggle="hover">
							<a class="nav-link main-link" href="#" role="button" data-toggle="dropdown"
								aria-haspopup="true" aria-expanded="false"
								:class="{ active: this.$route.name == 'aboutUs' }"><span>About
									Us</span></a>
							<div class="dropdown-menu">
								<ul class="navbar-nav sub_navbar_nav row" style="display: contents;">
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/aboutUs/SanmakView"
											:class="{ active: $route.path === '/main/aboutUs/SanmakView' }">About
											Sanmak</router-link>
									</li>
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/aboutUs/Contact"
											:class="{ active: $route.path === '/main/aboutUs/Contact' }">Contact
											Us</router-link>
									</li>
									<!-- <li class="nav-item col">
										<router-link class="nav-link" to="/main/aboutUs/Leave"
											:class="{ active: $route.path === '/main/aboutUs/Leave' }">
											Messages</router-link>
									</li> -->
									<li class="nav-item col">
										<router-link class="nav-link" to="/main/aboutUs/Vlog"
											:class="{ active: $route.path === '/main/aboutUs/Vlog' }">S-Vlog
										</router-link>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="navbar-brand custom_collapse">
				<div style="display: inline-block;padding-bottom: 0px;" @click="goFavorite">
					<a class="navbar-brand" href="#" style="font-size: 14px;">
						Favorites
						<span v-if="user||$isDevelopment" class="badge badge-warning circle">2</span>
					</a>

				</div>
				<div style="display: inline-grid; padding-left:1rem;">
					<!-- <p style="font-size: 14px;height: 18px;padding-top: 0px;">English</p> -->
					<a class="navbar-brand" href="#" style="font-size: 14px;">English</a>
				</div>
				<div style="display: inline-grid;">
					<div v-if="!user" style="padding-left: 1rem;align-items: end; ">
						<div style="display: inline-block;">
							<img src="/assets/img/Main/Nologin.png" style="max-height: 22px;margin-bottom: 2px;">
						</div>
						<div style="display: inline-block;text-align:left;padding-left: 0.25rem;">
							<!-- <p style="font-size: 14px;" @click="openFloatingModal">Login</p> -->
							<a class="navbar-brand" href="#" style="font-size: 14px;"
								@click="openFloatingModal">Login</a>
							<!-- <p v-if="!user" class="navbar-brand" style="font-size: 15px;padding-left: 1rem;"  @click="openFloatingModal" >Login</p> -->
						</div>
					</div>
					<div v-if="user" style="padding-left: 1rem; ">
						<div style="display: inline-block;">
							<img v-if="user" src="/assets/img/Main/userlogin.png"
								style="max-height: 18px;margin-bottom: 4px;">
						</div>
						<div style="display: inline-block;text-align:left;padding-left: 0.25rem;line-height:1;">
							<label v-if="user"
								style="font-size: 12px;margin: 0;pading:0; color:#FCB42E">{{user.name}}</label>
							<!-- <p style="font-size: 10px;margin: 0;pading:0;  ">{{this.$store.state.user.email}}</p> -->
						</div>
					</div>
				</div>
			</div>
		</nav>
		<div class="custom_content">
			<router-view :key="$route.fullPath"></router-view>

		</div>
		<BackToTop :intType="0" :intBlotTop="$route.name=='product'?600:0" />

		<Login></Login>
		<HomePage v-if="isModal1Visible" @close="isModal1Visible = false" @@sendMessage="getCenterTop"></HomePage>
		<footer class="bg-black pt-4 footer_color">
			<div class="container mb-4">
				<div class="row ">
					<div class="col-md-7 col-md " style="text-align: left;padding-top: 20px;">
						<h3 class="custom-color-primary">LOGIN FOR MORE INFORMATION</h3>
						<span class="d-block mt-2" style="color:#A2A2A2;line-height:1.2">
							After logging in, you can view the latest products, project progress, order progress, and
							other information related to your company.
							Your dynamic code is only used for local login once and must be resent to ensure your
							information is protected.
						</span>

						<div class="row footer_input" style="text-align: left;margin-left: -15px;">
							<div class="col-md-4  col-md mt-2 content_padding">
								<input type="text" class="form-control form-control-sm width_10"
									placeholder="Your Enterprise Email" onfocus="this.placeholder=''"
									onblur="this.placeholder='Your Enterprise Email'">
							</div>
							<div class="col-md-3 col-md mt-2 content_padding">
								<input type="text" class="form-control form-control-sm width_10"
									placeholder="Dynamic Code" onfocus="this.placeholder=''"
									onblur="this.placeholder='Dynamic Code'">
							</div>
							<div class="col-md-2 col-md mt-2 content_padding">
								<button type="submit" class="btn footer-btn-primary width_10"
									style="padding:0.25rem 0.5rem" @click="openFloatingModal">Get Code</button>
							</div>
							<div class="col-md-2 col-md mt-2 content_padding">
								<button class="btn footer-btn-primary width_10" style="padding:0.25rem 0.5rem"
									@click="openFloatingModal">Login</button>
							</div>
						</div>
					</div>
					<div class="col-md-5 col-md">
					</div>
				</div>
				<div class="row mt-5 main_fonts" style="text-align: left;">
					<div class="col-md-4" style="padding-top: 15px;text-align: center;">
						<img src="/assets/img/Main/sanmakLogo.png" style="width: 220px;">
					</div>
					<div class="col-md-8 row" style="font-family: Mongolian Baiti, Mongol; line-height:1.6">
						<!-- <div class="col-md-3"> -->
						<div style="padding-left: 40px;">
							<h5 class="mb-3 text-white">Products</h5>
							<ul class="list-main-footer text-secondary">
								<li>
									<router-link to="/main/products/Auxiliary Light"
										:class="{ active: this.$route.name == 'products' }"><span>Auxiliary
											Light</span></router-link>
									<!-- <a href="#" @click="Showproduct('Auxiliary Light')">Auxiliary Light</a> -->
								</li>
								<li>
									<router-link to="/main/products/Warning Light"
										:class="{ active: this.$route.name == 'products' }"><span>Warning
											Light</span></router-link>
									<!-- <a href="#">Warning Light</a> -->
								</li>
								<li>
									<router-link to="/main/products/Signal Light"
										:class="{ active: this.$route.name == 'products' }"><span>Signal
											Light</span></router-link>
									<!-- <a href="#">Signal Light</a> -->
								</li>
								<li>
									<router-link to="/main/products/Accessories"
										:class="{ active: this.$route.name == 'products' }"><span>Accessories</span></router-link>
									<!-- <a href="#">Accessories</a> -->
								</li>
							</ul>
						</div>
						<!-- <div class="col-md-2"> -->
						<div style="padding-left: 40px;">
							<h5 class="mb-3 text-white">Support</h5>
							<ul class="list-main-footer text-secondary">
								<li><a href="#">Instruction</a></li>
								<li>
									<router-link to="/main/vipCenter/ProjectProgress"
										:class="{ active: $route.path === '/main/vipCenter/ProjectProgress' }">Project</router-link>
									<!-- <a href="#">FAQ</a> -->
								</li>
								<li>
									<router-link to="/main/vipCenter/OrderProgress"
										:class="{ active: $route.path === '/main/vipCenter/OrderProgress' }">Order</router-link>
									<!-- <a href="#">Marketing</a> -->
								</li>
								<li>
									<router-link to="/main/download/ProductBrochure"
										:class="{ active: this.$route.name == 'download' }"><span>Download</span></router-link>
									<!-- <a href="#">Download</a> -->
								</li>
							</ul>
						</div>
						<div style="padding-left: 40px;">
							<h5 class="mb-3 text-white">About Us</h5>
							<ul class="list-main-footer text-secondary">
								<li>
									<router-link to="/main/aboutUs/Sanmak"
										:class="{ active: $route.path === '/main/aboutUs/Sanmak' }">Sanmak</router-link>
									<!-- <a href="#">Sanmak</a></li> -->
								<li>
									<router-link to="/main/news/NewsCom"
										:class="{ active: $route.path === '/main/news/NewsCom' }">News
									</router-link>
									<!-- <a href="#">News</a> -->
								</li>
								<li>
									<!-- <a class="text-muted" href="#">S Long</a> -->
									<router-link to="/main/aboutUs/Vlog"
										:class="{ active: $route.path === '/main/aboutUs/Vlog' }">S-Vlog
									</router-link>
								</li>
								<li>
									<router-link to="/main/aboutUs/Contact"
										:class="{ active: $route.path === '/main/aboutUs/Contact' }">Contact
									</router-link>
									<!-- <a href="#">Contact</a> -->
								</li>
							</ul>
						</div>
						<div style="padding-left: 40px;">
							<h5 class="mb-3 text-white">Contact</h5>
							<ul class="list-main-footer text-secondary">
								<li><a href="#">Tel: +86-757-81248088</a></li>
								<li><a href="#">Email: info@sanmak.com</a></li>
								<li><a href="#">Sanmak Lighting Co.,Ltd.</a></li>
								<li><a stype="white-space:nowrap" href="#">Sanmak Industry(Thailand) Co.,Ltd.</a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="footer_bottom_color"
				style="font-family: Avenir, Helvetica, Arial, sans-serif; font-size: 12px;">
				<div class="container row  pt-1 pb-1">
					<div class="col-md-6 text-left text-muted">
						<span>
							Copyright © 2010-Sanmak - All Rights Reserved.
						</span>

					</div>
					<div class="col-md-6 text-right">
						<span>
							<!-- <router-link :to="{ path: 'https://mail.163.com' }" target="_blank">Sanmak Email</router-link> -->
							<a :href="'https://mail.qiye.163.com/static/login/?from=NetEase163top'" target="_blank"
								class="list-main-footer text-muted">Sanmak Email</a>
						</span>
						<span class="text-muted pl-4 pr-4">|
						</span>
						<span class="list-main-footer text-secondary">
							<router-link :to="{path:'/BackLogin'}" target="_blank" class="list-main-footer text-muted">
								Background
							</router-link>
						</span>
					</div>
				</div>
			</div>

		</footer>
		<!--- END FOOTER -->
	</div>
</template>

<script>
	import BackToTop from '../../src/components/common/BackToTop.vue';
	import Login from '@/views/Login.vue';
	import HomePage from '@/views/home/HomePage.vue';
	import { getWebMenu } from "@/api/rbac/main";

	import {
		mapActions
	} from 'vuex';

	export default {
		data() {
			return {
				isModal1Visible: false,
				listMenu: [],
				intType: 0,
				intBlotTop: 0,
			}
		},
		name: 'HelloWorld',
		props: {
			msg: String
		},
		components: {
			BackToTop,
			Login,
			HomePage,
		},
		computed: {
			// 获取当前路由的名称
			currentRoute() {
				return this.$route.name || '未命名路由';
			},
			user() {
				return this.$store.state.user; // 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
			},

		},
		mounted() {
			// document.title = 'Sanmak Lighting Co.,Ltd';
			// console.log(this.$route.params.category); // 输出对应的分类，例如 "AuxiliaryLight"
			// console.log(this.$store.state.user);
			// this.getMenu1();

		},
		methods: {
			...mapActions('modal', ['openModal']), // 直接展示模态框
			...mapActions('modal', ['openFloatingModal']),
			goFavorite() {
				if (!this.user) {
					return;
				}
				if (this.$route.path !== '/main/vipCenter/Favorite') {
					this.$router.push('/main/vipCenter/Favorite');
				}
			},
			getMenu1() {
				try {
					getWebMenu().then((res) => {
						this.listMenu = res.data;
					});
				} catch (error) {
					console.log(error);
				}
			},
			// openBackGround(){
			// 	//打开后台管理系统
			// 	window.open()
			// }
			//
			Showproduct(typeName) {
				this.$router.push({ name: 'products', params: { category: typeName } })
			},
			handleNavigation(path) {
				if (this.user != null) {
					this.$router.push(path);
				} else {
					alert('You cannot navigate to this page right now.');
				}
			},
		},
		watch: {
			// '$route'(to, from) {
			// 	var baseProUrl='/main/products/'
			// 	console.log(to.path)
			// 	console.log(baseProUrl.length)
			// 	if (to.path.length>baseProUrl.length&&to.path.includes(baseProUrl)) {
			// 		console.log(111)
			// 		this.intType=1
			// 		this.intBlotTop=600
			// 	}
			// 	else{
			// 		this.intType=0
			// 		this.intBlotTop=0
			// 	}
			// 	// 当路由变化时，这个函数会被调用
			// 	console.log('路由从', from.path, '变化到', to.path);
			// 	// 在这里执行你的逻辑
			// }
		},
	}
</script>

<style scoped>
	input::placeholder {
		color: lightgray;
		/* 设置占位符文字颜色为灰色 */
		font-size: 14px;
		/* 可选：设置字体大小 */
	}

	:deep(.nav-ul) {
		display: flex;
		justify-content: space-between;
		padding: 0;
		margin: 0;
		list-style: none;
	}

	.circle {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		aspect-ratio: 1 / 1;
		position: relative;
		top: 0.1rem;
		right: 0.5rem;
		min-height: 0.8rem;
	}

	:deep(.nav-ul>li) {
		flex: 1;
		text-align: left;
	}

	:deep(.nav-ul>li>a) {
		margin-left: 1rem;
	}

	:deep(.sub_navbar_nav li) {
		height: 2.2rem !important;
		line-height: 2.2rem !important;
		display: flex;
		justify-content: left;
		align-items: center;
		width: 100%;
		font-size: 15px;
	}

	a.navbar-brand:hover {
		background-color: #FCB42E;
		color: #333 !important;
	}

	:deep(.sub_navbar_nav li a) {
		color: #fff;
		text-align: left;
		height: 2.2rem;
		line-height: 2.2rem;
		padding: 0rem 1rem;
		width: 100%;
	}

	li.nav-item:hover {
		background-color: #FCB42E;
		color: #333 !important;
	}

	/* li:not(:has(ul)):hover{
		background-color: #FCB42E;
	color: #333 !important;
	}
	li:has(ul):hover{
		background-color: #7fb80e;
	color: #333 !important;
	} */
	.sub_navbar_nav .active {
		background-color: #7fb80e;
		color: #333 !important;
	}

	.sub_navbar_nav li a:hover {
		background-color: #7fb80e;
		color: #333 !important;
	}

	.sub_navbar_nav .nav-link-select {
		background-color: #FCB42E;
		color: #333 !important;
	}

	.custom_navbar .navbar-nav>li {
		height: 3.75rem;
		line-height: 3.75rem;
	}

	.main-link {
		font-size: 16px;
	}

	.main-link.active span {
		height: 3.1rem;
		display: inline-block;
		border-bottom: 0.2rem solid #FCB42E;
	}

	/* :deep(.main-link.active::after span) {
	content: '';
	display: block;
	width: 3rem;
	height: 0.2rem;
	background-color: #FCB42E;
	margin: -0.8rem auto -0.4rem;
		margin: -0.8rem 0rem;
} */

	.footer_color {
		font-size: 14px;
	}

	.main_fonts {
		font-family: 'monbaiti', serif;
	}

	.footer_input .col-md {
		padding-right: 0;
	}

	@media (max-width: 576px) {
		.footer_color .container {
			padding-left: 15px;
			padding-right: 15px;
		}
	}

	@media (max-width: 768px) {

		.footer_color .row .col-md-3,
		.col-md-4,
		.col-md-2-1 {
			flex: 0 0 50%;
			max-width: 50%;
			padding-right: 0;
		}
	}

	@media (max-width: 992px) {

		.footer_color .row .col-md-3,
		.col-md-4,
		.col-md-2-1 {
			flex: 0 0 50%;
			max-width: 50%;
			padding-right: 0;
		}
	}

	:deep(.custom_content) {
		margin-top: 3.75rem;
	}

	@media (max-width: 1199.9px) {
		.custom_collapse {
			display: none;
		}
	}

	@media (min-width: 576px) {
		.custom_navbar .container {
			max-width: 576px;
		}
	}

	@media (min-width: 768px) {
		.custom_navbar .container {
			max-width: 768px;
		}

		.col-1-1 {
			max-width: 100%;
		}
	}

	@media (min-width: 992px) {
		.custom_navbar .container {
			max-width: 992px;
		}
	}

	@media (min-width: 1200px) {
		.custom_navbar .container {
			max-width: 992px;
		}
	}

	#disablelist li a:hover {
		background-color: lightgray;
		color: white !important;
	}
</style>